<input
  type="file"
  [disabled]="loading$ | async"
  [style.display]="'none'"
  #fileInput
  accept=".csv,.xls,.xlsx"
  (change)="changed()"
  />
<button
  ca-raised-button
  [disabled]="loading$ | async"
  (click)="fileInput.click()"
  >
  Select File
</button>

@if (file) {
  <div>
    <div class="flex justify-between align-middle mt-4 mb-4">
      <h3 class="mt-0 mb-0">Data Preview</h3>
      @if (!(results$ | async)) {
        <a
          (click)="submit()"
          [disabled]="loading$ | async"
          ca-raised-button
          >Import</a
          >
        }
      </div>
      @if (loading$ | async) {
        <mat-progress-bar
          mode="indeterminate"
        ></mat-progress-bar>
      }
      <member-import-csv-preview
        [config]="config"
        [loading]="loading$ | async"
        [error]="error$ | async"
        [results]="results$ | async"
        [file]="file"
      ></member-import-csv-preview>
    </div>
  }
